import styled from 'styled-components';
import { BREAKPOINT } from '@latitude/core/utils/constants';
export const Outer = /*#__PURE__*/styled.div.withConfig({
  displayName: "SiteLinksstyles__Outer",
  componentId: "sc-4koc9s-0"
})(["@media (min-width:", "){background-color:#fff;}"], BREAKPOINT.LG);
export const Inner = /*#__PURE__*/styled.div.withConfig({
  displayName: "SiteLinksstyles__Inner",
  componentId: "sc-4koc9s-1"
})(["width:100%;padding:0 20px;margin:0 auto;@media (min-width:", "){max-width:960px;padding:32px 20px;}@media (min-width:", "){max-width:1140px;}"], BREAKPOINT.LG, BREAKPOINT.XL);
export const Mobile = /*#__PURE__*/styled.div.withConfig({
  displayName: "SiteLinksstyles__Mobile",
  componentId: "sc-4koc9s-2"
})(["display:block;margin:-125px 0 0;background-color:#dae3e7;@media (min-width:", "){display:none;}"], BREAKPOINT.LG);
export const Desktop = /*#__PURE__*/styled.div.withConfig({
  displayName: "SiteLinksstyles__Desktop",
  componentId: "sc-4koc9s-3"
})(["display:none;background-color:#fff;@media (min-width:", "){display:block;}"], BREAKPOINT.LG);
export const SiteLinksGroup = /*#__PURE__*/styled.div.withConfig({
  displayName: "SiteLinksstyles__SiteLinksGroup",
  componentId: "sc-4koc9s-4"
})(["display:flex;flex-wrap:wrap;justify-content:space-between;"]);
export const CardContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "SiteLinksstyles__CardContainer",
  componentId: "sc-4koc9s-5"
})(["position:relative;top:-20px;max-width:270px;text-align:center;img{width:100%;}a{display:inline-block;}"]);
export const List = /*#__PURE__*/styled.ul.withConfig({
  displayName: "SiteLinksstyles__List",
  componentId: "sc-4koc9s-6"
})(["list-style-type:none;margin:0;padding:1rem 1.5rem;@media (min-width:", "){padding:0;}"], BREAKPOINT.LG);
export const ListItem = /*#__PURE__*/styled.li.withConfig({
  displayName: "SiteLinksstyles__ListItem",
  componentId: "sc-4koc9s-7"
})(["margin-bottom:1rem;&:last-child{margin-bottom:0;}"]);